module.exports = __webpack_public_path__ + "static/media/scr_onboarding_03_a.1021f2e5.png";